import { connect } from 'react-redux';
import NavSmallScreen from '../components/blocks/navigation/NavSmallScreen';
import { openModal } from '../redux/actions/modal';
import { CHECKIN_MODAL } from '../redux/reducers/modal';
import { selectHasActiveIncidents } from '../redux/selectors/incidents';
import type { State } from '../types';

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  hasActiveIncidents: selectHasActiveIncidents(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  onOpenCheckinModal: () => {
    dispatch(openModal({ id: CHECKIN_MODAL, display: true, disableButtons: false }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavSmallScreen);
